// extracted by css-extract-rspack-plugin
export default {"root":"root-L_VtZy","glyph":"glyph-yMtU6A"};